import * as React from "react";
import { cn } from "../../lib/utils";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "ghost" | "outline";
  size?: "sm" | "md" | "lg";
};

export function Button({ className, variant = "primary", size = "md", ...props }: ButtonProps) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-full text-sm font-black transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pink focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:pointer-events-none disabled:opacity-50",
        size === "sm" && "px-4 py-2",
        size === "md" && "px-5 py-3",
        size === "lg" && "px-6 py-4",
        variant === "primary" && "bg-pink text-white shadow-sm hover:bg-pink/90",
        (variant === "secondary" || variant === "outline") && "border border-slate-300 bg-white text-text shadow-sm hover:border-pink hover:bg-slate-50",
        variant === "ghost" && "text-muted hover:bg-slate-100 hover:text-text",
        className,
      )}
      {...props}
    />
  );
}